import { StoreFlag } from 'commons/enums/StoreFlag.enum';
import useStoreInfo from './useStoreInfo';

export function useStoreFlag(flag: StoreFlag) {
  const { storeInfo } = useStoreInfo();
  return {
    enabled: storeInfo.flags.includes(flag),
  };
}
